import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disableVisibilitySwitch"];
import React from "react";
import TextInput from "../TextInput";
import { passwordProps } from "./constants";
import usePasswordVisible from "./hooks/usePasswordVisible";
import { jsx as _jsx } from "react/jsx-runtime";
var PasswordInput = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var disableVisibilitySwitch = _ref.disableVisibilitySwitch,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePasswordVisible = usePasswordVisible(false),
    passwordVisible = _usePasswordVisible.passwordVisible,
    setPasswordVisible = _usePasswordVisible.setPasswordVisible;
  if (disableVisibilitySwitch) {
    return /*#__PURE__*/_jsx(TextInput, _extends({}, props, {
      type: "password"
    }));
  }
  var _passwordProps$String = passwordProps[String(passwordVisible)],
    icon = _passwordProps$String.icon,
    tooltipContent = _passwordProps$String.tooltipContent,
    type = _passwordProps$String.type;
  return /*#__PURE__*/_jsx(TextInput, _extends({}, props, {
    type: type,
    adornEnd: {
      type: "iconButton",
      props: {
        icon: icon,
        onClick: function onClick() {
          return setPasswordVisible(!passwordVisible);
        },
        tooltipContent: tooltipContent
      }
    },
    ref: forwardedRef
  }));
});
PasswordInput.displayName = "PasswordInput";
export default PasswordInput;